import { render, staticRenderFns } from "./AppEmailBestaetigung.vue?vue&type=template&id=401227a0&"
import script from "./AppEmailBestaetigung.vue?vue&type=script&lang=js&"
export * from "./AppEmailBestaetigung.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports